import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Bell, PartyPopper, LockKeyhole, Check } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Notifications = () => {
  const [list, setList] = useState(null);
  useEffect(() => {
    fetch(`${API}/notifications/me`, { credentials: 'include' }).then((r) => (r.ok ? r.json() : [])).then(setList).catch(() => setList([]));
  }, []);
  const markRead = async (id) => {
    await fetch(`${API}/notifications/${id}/read`, { method: 'PUT', credentials: 'include' }).catch(() => {});
    setList((l) => l.map((n) => (n.id === id ? { ...n, read: true } : n)));
  };
  const unread = (list || []).filter((n) => !n.read).length;
  return (
    <div className="sc-card p-6 md:p-8 mb-6" data-testid="notifications-card">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
        <div className="flex items-center gap-2"><Bell size={14} className="text-amber-500" /><h2 className="sc-mono-eyebrow text-amber-500">Avisos</h2></div>
        {unread > 0 && <span className="text-[11px] font-mono uppercase tracking-widest text-amber-500 border border-amber-500/40 px-2 py-0.5 rounded" data-testid="notifications-unread">{unread} sin leer</span>}
      </div>
      {list === null && <div className="w-6 h-6 border-2 border-amber-500 border-t-transparent rounded-full animate-spin" />}
      {list && list.length === 0 && <p className="text-sm text-slate-400" data-testid="notifications-empty">Sin avisos. Aquí te informaremos cuando una oferta a la que has postulado se cierre o te seleccionen.</p>}
      {list && list.length > 0 && (
        <div className="space-y-3">
          {list.map((n) => {
            const sel = n.type === 'selected';
            return (
              <div key={n.id} data-testid={`notification-${n.type}`} className={`sc-card p-4 flex gap-3 ${sel ? 'border-emerald-500/60 bg-emerald-500/5' : ''} ${n.read ? 'opacity-70' : ''}`}>
                <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${sel ? 'bg-emerald-500/15 text-emerald-400' : 'bg-[#1A1D24] text-slate-400'}`}>{sel ? <PartyPopper size={16} /> : <LockKeyhole size={16} />}</div>
                <div className="flex-1 min-w-0">
                  <div className={`text-sm font-semibold ${sel ? 'text-emerald-300' : 'text-white'}`}>{n.title}</div>
                  <p className="text-sm text-slate-300 leading-relaxed mt-1">{n.message}</p>
                  <div className="flex items-center justify-between gap-3 mt-2 flex-wrap">
                    <Link to={`/ofertas/${n.job_id}`} data-testid={`notification-job-${n.id}`} className="text-[11px] font-mono uppercase tracking-widest text-amber-500 hover:underline">Ver oferta</Link>
                    {n.conversation_id && <Link to={`/mensajes/${n.conversation_id}`} data-testid={`notification-chat-${n.id}`} className="text-[11px] font-mono uppercase tracking-widest text-emerald-400 hover:underline">Abrir conversación</Link>}
                    <div className="flex items-center gap-3 text-[11px] text-slate-500 font-mono">
                      <span>{new Date(n.created_at).toLocaleString('es-ES', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}</span>
                      {!n.read && <button type="button" data-testid={`notification-read-${n.id}`} onClick={() => markRead(n.id)} className="inline-flex items-center gap-1 hover:text-amber-500"><Check size={11} /> Marcar leído</button>}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Notifications;
